import cn from 'classnames';
import { useCallback, useContext } from 'react';

import { AuthFormContext } from '@webapp/account/src/components/auth/context';

import { CheckMark } from '@webapp/common/assets/icons';

import css from './auth-input.css';

// TODO https://www.chromium.org/developers/design-documents/form-styles-that-chromium-understands/

export const AuthInput: FC<{
    name: string;
    error: string;
    value: string;
    label: string;
    focused: boolean;
    onBlur: (e: any) => void;
    onChange: (e: any) => void;
    onFocus: (e: any) => void;
    onSubmit?: (form) => void;
    className?: string;
    type?: 'text' | 'password';
    disabled?: boolean;
    autoComplete?: string;
    suffix?: ReactNode;
    isValidatePassword?: boolean;
}> = ({
    autoComplete,
    className,
    disabled,
    error,
    focused,
    label,
    name,
    onBlur,
    onChange,
    onFocus,
    onSubmit,
    suffix,
    type,
    value,
    isValidatePassword,
}) => {
    const form = useContext(AuthFormContext);
    const onKeyDown = useCallback(
        (e) => {
            if (e.keyCode === 13 && onSubmit) {
                onSubmit(form);
                e.preventDefault();
            }
        },
        [form, onSubmit],
    );

    const getError = (errorName: string): boolean => {
        if (!value) {
            return true;
        }
        if (errorName === 'latinUppercaseOrLower' && (!value.match('[A-Z]') || !value.match('[a-z]'))) {
            return true;
        } else if (errorName === 'specialOrNumeric' && !value.match('[0-9]') && !value.match('[!@#$%^&*_]')) {
            return true;
        } else return errorName === 'length' && value.trim().length < 8;
    };

    return (
        <label
            className={cn(css.field, className, {
                [css.fieldFocused]: focused,
                [css.fieldHasError]: !!error,
                [css.fieldHasValue]: !!value,
                [css.fieldDisabled]: disabled,
            })}
        >
            <div className={css.label}>{label}</div>
            <div className={css.wrapper}>
                <input
                    autoComplete={autoComplete}
                    className={css.input}
                    disabled={disabled}
                    name={name}
                    placeholder={label}
                    type={type}
                    value={value || ''}
                    onBlur={onBlur}
                    onChange={onChange}
                    onFocus={onFocus}
                    onKeyDown={onKeyDown}
                />
                {suffix && <div className={css.suffix}>{suffix}</div>}
            </div>
            <>
                {isValidatePassword ? (
                    <div className={css.rules}>
                        <div
                            className={cn(
                                css.rule,
                                getError('latinUppercaseOrLower') ? `${css.error} ${css.dot}` : css.success,
                            )}
                        >
                            {getError('latinUppercaseOrLower') ? '' : <CheckMark />}
                            Латинские буквы разного регистра
                        </div>
                        <div
                            className={cn(
                                css.rule,
                                getError('specialOrNumeric') ? `${css.error} ${css.dot}` : css.success,
                            )}
                        >
                            {getError('specialOrNumeric') ? '' : <CheckMark />}
                            Цифры или спецсимволы
                        </div>
                        <div className={cn(css.rule, getError('length') ? `${css.error} ${css.dot}` : css.success)}>
                            {getError('length') ? '' : <CheckMark />}
                            Не короче 8 символов
                        </div>
                    </div>
                ) : (
                    <div className={css.error}>{error}</div>
                )}
            </>
        </label>
    );
};
